import bookIcon from "../assets/images/icons/Vector.svg";
import taskFrame from "../assets/images/icons/Rectangle 12.svg";
import EstateActivityLayout from "../components/EstateActivityLayout";
import { useTranslation } from "../components/Localization";

export default function EstateBookTaskPage() {
  const { t } = useTranslation();
  return <EstateActivityLayout taskKey="book" step={0} progressIcon="bottom-left" backTo="/petkiek" nextTo="/petkiek/katona">
    <button className="task-icon-button estate-book" aria-label={t("accessibility.digitalBook")}><img className="task-frame" src={taskFrame} alt="" /><img className="task-symbol estate-book-symbol" src={bookIcon} alt="" /><span className="estate-book-lines" aria-hidden="true" /></button>
  </EstateActivityLayout>;
}
